export const License = "License/";

export const ExpressEE123Interest = License + "ExpressEE123Interest"; 